.root {
  position: relative;
}

.progress {
  display: flex;
  position: absolute;
  z-index: 1;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
  opacity: 0;

  transition: 0.15s ease-in-out opacity;
}

.visible .progress {
  opacity: 1;
}

.children {
  opacity: 1;

  transition: 0.15s ease-in-out opacity;
}

.hideChildren.visible .children {
  opacity: 0;
}
